import { useEffect } from 'react';
import { useStore } from '~/store';
import { commitMatte } from './actions';

/**
 * After reload, persisted `step === 'sprite'` is restored without its
 * `committedCleaned` snapshot (intentionally not persisted — too large).
 * Once the matte pipeline has produced fresh output, copy it back into the
 * commit so the sprite step has something to render. Runs once per visit.
 */
export function useAutoCommitOnRehydrate(): void {
  const step = useStore((s) => s.workflow.step);
  const committed = useStore((s) => s.workflow.committedCleaned);
  const cleaned = useStore((s) => s.background.cleaned);
  useEffect(() => {
    if (step === 'sprite' && !committed && cleaned) commitMatte();
  }, [step, committed, cleaned]);
}
